import React from 'react';
import { FormattedMessage } from 'react-intl';

import ChartHiddenSeriesOverlay from 'components/charts/chart-hidden-series-overlay';

const BenchmarkChartHiddenSeriesOverlay: React.FC<React.SVGAttributes<SVGTextElement>> = (props) => {
  return (
    <ChartHiddenSeriesOverlay {...props} message={<FormattedMessage id="benchmarkAnalytics.growthPage.chart.allHidden" />} />
  );
};

export default BenchmarkChartHiddenSeriesOverlay;
